import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Contact() {
  return <section id="contact" className="py-28 px-6 md:px-12 relative overflow-hidden" style={{
    backgroundColor: '#F4F6ED'
  }} data-id="element-55">
      {/* Decorative elements */}
      <div className="absolute top-40 left-10 w-24 h-24 border border-dashed border-ink-300 rounded-full opacity-30" data-id="element-56"></div>
      <div className="absolute bottom-40 right-10 w-16 h-16 border border-dotted border-ink-300 rounded-full opacity-30" data-id="element-57"></div>
      <div className="absolute top-1/2 left-0 w-32 h-px bg-ink-300 opacity-30" data-id="element-58"></div>
      <div className="absolute top-1/2 right-0 w-32 h-px bg-ink-300 opacity-30" data-id="element-59"></div>
      <div className="container mx-auto max-w-6xl" data-id="element-60">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-61">
          <div className="relative inline-block" data-id="element-62">
            <h2 className="text-3xl md:text-4xl font-currency italic tracking-wide mb-6 currency-heading" data-id="element-63">
              Get in Touch
            </h2>
            <div className="absolute -right-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-64"></div>
            <div className="absolute -left-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-65"></div>
          </div>
          <p className="text-ink-600 max-w-2xl mx-auto font-serif" data-id="element-66">
            Let's discuss how I can help your team turn ambiguity into shipped
            outcomes.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-67">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-68">
            <div className="bg-white border border-ink-100 p-10 relative" data-id="element-69">
              {/* Added decorative corner lines */}
              <div className="absolute top-0 left-0 w-5 h-5 border-t border-l border-ink-200" data-id="element-70"></div>
              <div className="absolute top-0 right-0 w-5 h-5 border-t border-r border-ink-200" data-id="element-71"></div>
              <div className="absolute bottom-0 left-0 w-5 h-5 border-b border-l border-ink-200" data-id="element-72"></div>
              <div className="absolute bottom-0 right-0 w-5 h-5 border-b border-r border-ink-200" data-id="element-73"></div>
              <h3 className="text-2xl font-currency tracking-wide mb-8" data-id="element-74">
                Contact Information
              </h3>
              <div className="space-y-8" data-id="element-75">
                <div className="flex items-start" data-id="element-76">
                  <div className="text-racing-500 mr-5" data-id="element-77">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-78">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-79" />
                    </svg>
                  </div>
                  <div data-id="element-80">
                    <p className="text-ink-700 font-currency tracking-wide mb-1" data-id="element-81">
                      Email
                    </p>
                    <a href="mailto:davood@primeroadmap.com" className="text-ink-600 hover:text-racing-500 font-serif" data-id="element-82">
                      davood@primeroadmap.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-83">
                  <div className="text-racing-500 mr-5" data-id="element-84">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-85">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" data-id="element-86" />
                    </svg>
                  </div>
                  <div data-id="element-87">
                    <p className="text-ink-700 font-currency tracking-wide mb-1" data-id="element-88">
                      LinkedIn
                    </p>
                    <a href="https://linkedin.com/in/davoodtr" className="text-ink-600 hover:text-racing-500 font-serif" data-id="element-89">
                      linkedin.com/in/davoodtr
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-90">
                  <div className="text-racing-500 mr-5" data-id="element-91">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-92">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-93" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-94" />
                    </svg>
                  </div>
                  <div data-id="element-95">
                    <p className="text-ink-700 font-currency tracking-wide mb-1" data-id="element-96">
                      Location
                    </p>
                    <p className="text-ink-600 font-serif" data-id="element-97">
                      London, United Kingdom
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-98">
            <div className="bg-white border border-ink-100 p-10 relative" data-id="element-99">
              {/* Added decorative corner lines */}
              <div className="absolute top-0 left-0 w-5 h-5 border-t border-l border-ink-200" data-id="element-100"></div>
              <div className="absolute top-0 right-0 w-5 h-5 border-t border-r border-ink-200" data-id="element-101"></div>
              <div className="absolute bottom-0 left-0 w-5 h-5 border-b border-l border-ink-200" data-id="element-102"></div>
              <div className="absolute bottom-0 right-0 w-5 h-5 border-b border-r border-ink-200" data-id="element-103"></div>
              <h3 className="text-2xl font-currency tracking-wide mb-6" data-id="element-104">
                Book a Call
              </h3>
              <p className="text-ink-600 mb-8 font-serif" data-id="element-105">
                Schedule a free 30-minute consultation to discuss your product
                challenges and how I can help.
              </p>
              <a href="https://calendly.com/davood-primeroadmap/30min" target="_blank" rel="noopener noreferrer" data-id="element-106">
                <Button className="w-full" data-id="element-107">Schedule a call</Button>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}